import { BrowserRouter } from "react-router-dom";
import RoutesHOC from "./routes/RoutesHOC";
import "./App.css";
import { ToastContainer, toast, Id as ToastId } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTokenExpirationCheck from "./hooks/useTokenExpirationCheck";
import ErrorBoundary from "./components/error/ErrorBoundary";
import { useEffect, useState } from "react";
import socket from "./socket";
import CallDetailDialog from "./components/callToDocterNotification";
import { useSelector } from "react-redux";

const App = () => {
  useTokenExpirationCheck();
  const [callData, setCallData] = useState<any>(null);
  const [callDialogOpened, setCallDialogOpened] = useState(false);
  const profile = useSelector((state: any) => state?.profileSlice?.profile);
  // Track connection status
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  useEffect(() => {
    // Connect to the socket
    socket.on("connect", () => {
      console.log("Connected to the server");
    });

    // Handle disconnection
    socket.on("disconnect", () => {
      console.log("Server is disconnected!");
    });

    // Listen for 'sendNotifyEvent'
    socket.on(profile?.data?._id, (data: any) => {
      data = data.data;
      console.log("Notification data received:", data);
      if (data?.type == "callToDoctor") {
        setCallData(data);
        setCallDialogOpened(true);
      } else {
        return;
      }
    });

    // Clean up the event listeners on component unmount
    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("sendNotifyEvent");
    };
  }, [socket, profile?.data?._id]);
  // Handle online/offline status
  useEffect(() => {
    // Toast ID to keep track of the offline toast - explicitly typed as ToastId or null
    let offlineToastId: ToastId | null = null;

    // Function to show toast for online status
    const handleOnline = () => {
      // Clear the offline toast if it exists
      if (offlineToastId !== null) {
        toast.dismiss(offlineToastId);
        offlineToastId = null;
      }

      setIsOffline(false);

      toast.success("You're online now! Hurray! Internet is connected.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    };

    // Function to show persistent toast for offline status
    const handleOffline = () => {
      setIsOffline(true);

      // Create a persistent toast that doesn't auto-close
      offlineToastId = toast.error(
        "You're offline now! Oops! Internet is disconnected.",
        {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false, // Prevent closing by clicking
          pauseOnHover: true,
          draggable: false, // Prevent dragging
          closeButton: false, // Remove close button
          className: "persistent-offline-toast",
        }
      );
    };

    // Check initial status
    if (!navigator.onLine) {
      handleOffline();
    }

    // Add event listeners for online/offline events
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      if (offlineToastId !== null) {
        toast.dismiss(offlineToastId);
      }
    };
  }, []); // Empty dependency array to run once on mount

  return (
    <div className="app-container">
      {/* Overlay to block interactions when offline */}
      {isOffline && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            zIndex: 1000,
            pointerEvents: "all", // Block all interactions
            cursor: "not-allowed",
          }}
        />
      )}

      {/* <ErrorBoundary > */}
      <BrowserRouter>
        <RoutesHOC />
        <ToastContainer />
        <CallDetailDialog
          open={callDialogOpened}
          onClose={() => setCallDialogOpened(false)}
          data={callData}
        />
      </BrowserRouter>
      {/* </ErrorBoundary> */}
    </div>
  );
};

export default App;
